export default __webpack_public_path__ + "static/media/Spyros1.962373d8.jpg";